"use client";

import { PaymentDaysContext } from "contexts/PaymentDaysContext";

export function PaymentDaysProvider({ children, paymentDaysContextValue }) {
  return (
    <PaymentDaysContext.Provider value={paymentDaysContextValue}>
      {children}
    </PaymentDaysContext.Provider>
  );
}
